<!-- eslint-disable @angular-eslint/template/role-has-required-aria -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div [attr.aria-label]="'searchBox.productSearch' | cxTranslate" role="search">
  <label class="searchbox" [class.dirty]="!!searchInput.value" [ngClass]="{ 'is-active': isAtive }">
    <!-- TODO: (CXSPA-6929) - Remove feature flag next major release -->
    <input
      #searchInput
      class="input-search"
      [placeholder]="'searchBox.placeholder' | cxTranslate"
      autocomplete="off"
      aria-describedby="initialDescription"
      aria-controls="results"
      [attr.tabindex]="a11ySearchBoxMobileFocusEnabled ? getTabIndex(isMobile | async) : null"
      [attr.aria-label]="'searchBox.placeholder' | cxTranslate"
      (focus)="a11ySearchBoxMobileFocusEnabled ? null : open()"
      (click)="open()"
      (input)="search(searchInput.value)"
      (blur)="close($any($event))"
      (keydown.tab)="a11ySearchBoxMobileFocusEnabled ? close($any($event)) : null"
      (keydown.escape)="close($any($event))"
      (keydown.enter)="close($any($event), true); launchSearchResult($any($event), searchInput.value); updateChosenWord(searchInput.value)"
      (keydown.arrowup)="focusPreviousChild($any($event))"
      (keydown.arrowdown)="focusNextChild($any($event))"
      value="{{ chosenWord }}"
    />

    <button
      [attr.aria-label]="'common.reset' | cxTranslate"
      [title]="'common.reset' | cxTranslate"
      (click)="clear(searchInput)"
      class="reset"
    >
      <span class="material-symbols-outlined text-danger"> close </span>
    </button>

    <div
      role="presentation"
      class="search-icon c-pointer"
      [title]="'common.search' | cxTranslate"
      (click)="handlerSearchMobile($event, searchInput)"
    >
      <span class="material-symbols-outlined text-primary"> search </span>
    </div>

    <button
      #searchButton
      [attr.aria-label]="'common.search' | cxTranslate"
      [title]="'common.search' | cxTranslate"
      class="search"
      (click)="open()"
    >
      <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
    </button>
  </label>
</div>

<div
  *ngIf="{
    result: results$ | async,
    content: contents$ | async,
  } as content"
  class="results"
  id="results"
  (click)="close($any($event), true)"
  role="dialog"
>
  <div *ngIf="content.result?.message" class="message" [innerHTML]="content.result?.message"></div>
  <!--RESULT  SUGGESTIONS-->
  <ng-container>
    <div class="message" *ngIf="content.result?.suggestions?.length">
      {{ 'searchBox.suggestions' | cxTranslate }}
    </div>
  </ng-container>

  <ul class="suggestions" attr.aria-label="{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}" role="listbox">
    <li *ngFor="let suggestion of content.result?.suggestions">
      <a
        role="option"
        [innerHTML]="suggestion | cxHighlight: searchInput.value"
        [routerLink]="
          {
            cxRoute: 'search',
            params: { query: suggestion },
          } | cxUrl
        "
        (keydown.arrowup)="focusPreviousChild($any($event))"
        (keydown.arrowdown)="focusNextChild($any($event))"
        (keydown.enter)="close($any($event), true)"
        (keydown.escape)="close($any($event), true)"
        (blur)="close($event)"
        (mousedown)="preventDefault($event)"
        (click)="
          dispatchSuggestionEvent({
            freeText: searchInput.value,
            selectedSuggestion: suggestion,
            searchSuggestions: content.result?.suggestions ?? [],
          });
          updateChosenWord(suggestion)
        "
      >
      </a>
    </li>
  </ul>

  <!--  RECENT SEARCHES-->
  <ng-container>
    <ng-template
      *ngIf="config.recentSearches"
      [cxOutlet]="searchBoxOutlets.RECENT_SEARCHES"
      [cxOutletContext]="{
        search: searchInput.value,
        searchBoxActive: searchBoxActive,
        maxRecentSearches: config.maxRecentSearches,
      }"
    ></ng-template>
  </ng-container>

  <!--RESULT  PRODUCTS-->
  <ng-container>
    <div class="message" *ngIf="content.result?.products?.length">
      {{ 'searchBox.products' | cxTranslate }}
    </div>
  </ng-container>

  <ul class="products" *ngIf="content.result?.products" attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}" role="listbox">
    <li *ngFor="let product of content.result?.products | slice: 0 : 3">
      <a
        role="option"
        [routerLink]="
          {
            cxRoute: 'product',
            params: product,
          } | cxUrl
        "
        [class.has-media]="config.displayProductImages"
        (keydown.arrowup)="focusPreviousChild($any($event))"
        (keydown.arrowdown)="focusNextChild($any($event))"
        (keydown.enter)="close($any($event), true)"
        (keydown.escape)="close($any($event), true)"
        (blur)="close($any($event))"
        (mousedown)="preventDefault($event)"
        (click)="
          dispatchProductEvent({
            freeText: searchInput.value,
            productCode: product.code,
          })
        "
      >
        <div class="product-content">
          <cx-media
            *ngIf="config.displayProductImages"
            [container]="product.images?.PRIMARY"
            format="thumbnail"
            role="presentation"
          ></cx-media>

          <div class="box-details">
            <div class="name" [innerHTML]="product.nameHtml"></div>

            <p class="items" *ngIf="product?.customerPartNumber">
              <span class="title">{{ 'intro.customer' | cxTranslate }}#: </span><span class="value">{{ product?.customerPartNumber }}</span>
            </p>

            <p class="items">
              <span class="title">{{ 'intro.part' | cxTranslate }}#: </span><span class="value">{{ product?.partNumber }}</span>
            </p>

            <p class="items">
              <span class="title">{{ 'intro.catalog' | cxTranslate }}#: </span><span class="value">{{ product?.catalogNumber }}</span>
            </p>
          </div>
        </div>
      </a>
    </li>
  </ul>

  @if (content.content?.pages?.length) {
    <div class="container-content">
      <div class="message">Content Suggestion</div>

      <ul class="contents" role="listbox">
        <li *ngFor="let page of content.content?.pages">
          <a [routerLink]="[page.url]" (mousedown)="preventDefault($event)">
            <span class="d-flex material-symbols-outlined m-r-12"> article </span>

            <div class="details">
              <p class="title">{{ page.title }}</p>
              <p class="content">{{ page.description }}</p>
            </div>
          </a>
        </li>
      </ul>
    </div>
  }

  <span id="initialDescription" class="cx-visually-hidden">
    {{ 'searchBox.initialDescription' | cxTranslate }}
  </span>

  <div *ngIf="content.result?.suggestions?.length || content.result?.products?.length" aria-live="assertive" class="cx-visually-hidden">
    {{ 'searchBox.suggestionsResult' | cxTranslate: { count: content.result?.suggestions?.length } }}
    {{ 'searchBox.productsResult' | cxTranslate: { count: content.result?.products?.length } }}
    {{ 'searchBox.initialDescription' | cxTranslate }}
  </div>
</div>
